import Layout from '@/layout'
const materialManagementRouter = {
    path: '/MaterialManagement',
    component: Layout,
    redirect: '/MaterialManagement/MaterialList',
    name: 'MaterialManagement',
    alwaysShow: true,
    meta: {
        title: '素材管理',
        icon: 'celebrity'
        // icon: 'MaterialManagement'
    },
    children: [
        {
         path: '/MaterialManagement/MaterialList',
         name: "MaterialList",
         component: () => import("@/views/materialManagement/materialList/index.vue"),
         meta: {
           title: "素材列表",
         }
       },
     ]
}

export default materialManagementRouter;